require('./bootstrap');

let http = require('./http');

let moment = require('moment');
moment().format();

//Sets auto saves to 3 hours
let autoSaveInitialized = false;
let autoSaveAttemptMax = window.autoSaveAttemptMax;
let autoSaves = 0;
let autoSaveInterval = window.autoSaveInterval;

export const initGuideScripts = function () {

    $('.guide-client-evaluation').validate({
        errorElement: 'div',
        validClass: "",
    });

    $('#evaluation').validate({
        errorElement: 'div',
        validClass: "",
    });

    $('.toggle-feedback-block').on('click', function (e) {
        e.preventDefault();
        let el = $(this);

        $('.toggle-feedback-block').show().html('+');
        el.hide();
        // el.html('-');

        let idx = el.data('feedback-block-idx');
        $('.feedback-block-body').hide();

        $('#feedback-block-' + idx + '-body').show();
    })

    // $(document).on('change', '.client_did_summit', function () {
    //     let addSummit = $(this).closest(":has(.client-summit-2)").find('.client-summit-2');
    //     if ($(this).val() == '0' || $(this).val() == '') {
    //         $(this).closest(':has(.client_did_summit_date)').find('.client_did_summit_date').prop('disabled', true);
    //         $(this).closest(':has(.summited_date_label)').find('.summited_date_label').addClass('hide');
    //         addSummit.attr('disabled', true);
    //     } else {
    //         $(this).closest(':has(.client_did_summit_date)').find('.client_did_summit_date').prop('disabled', false);
    //         addSummit.attr('disabled', false);
    //         $(this).closest(':has(.summited_date_label)').find('.summited_date_label').removeClass('hide');

    //     }
    // });

    $(document).on('change', '.guide_did_summit', function () {
        console.log("Change");
        if ($(this).val() == '0' || $(this).val() == '') {
            $(this).closest(':has(.guide_did_summit_date)').find('.guide_did_summit_date').prop('disabled', true);
            $(this).closest(':has(.guide_did_summit_date_label)').find('.guide_did_summit_date_label').addClass('hide');
        } else {
            $(this).closest(':has(.guide_did_summit_date)').find('.guide_did_summit_date').prop('disabled', false);
            $(this).closest(':has(.guide_did_summit_date_label)').find('.guide_did_summit_date_label').removeClass('hide');

        }
    });

    // $(document).on('change', '.client-summit-2', function () {
    //     let dateElementContainer = $(this).closest(":has(.client-summit-date-2)").find('.client-summit-date-2');
    //     let dateElement = dateElementContainer.find('input[type=date]');
    //     if ($(this).is(':checked')) {
    //         dateElementContainer.removeClass('hide');
    //         dateElement.attr('disabled', false);
    //     } else {
    //         dateElementContainer.addClass('hide');
    //         dateElement.attr('disabled', true);
    //     }
    // })

    $(document).on('change', '.guide_left_early', function () {
        if ($(this).val() == '0' || $(this).val() == '') {
            $(this).closest(':has(.guide_left_early_date)').find('.guide_left_early_date').prop('disabled', true);
            $(this).closest(':has(.guide_left_early_date_label)').find('.guide_left_early_date_label').addClass('hide');
        } else {
            $(this).closest(':has(.guide_left_early_date)').find('.guide_left_early_date').prop('disabled', false);
            $(this).closest(':has(.guide_left_early_date_label)').find('.guide_left_early_date_label').removeClass('hide');

        }
    });

    $(document).on('click', '.add-left-early', function () {
        let clone = $('.left-early:last').clone();

        $('.left-early:last').after(clone);
    });

    $(document).on('change', '#client-guide-name', function () {
        if ($(this).val() !== '') {
            $('#client-guide-date').prop('disabled', false);
        } else {
            $('#client-guide-date').prop('disabled', true);
        }
    });

    $(document).on('change', '#client-guide-date', function () {
        if ($(this).val() !== '') {
            let now = new Date;
            let input = new Date($(this).val());

            if (input.getTime() < now.getTime()) {
                $('#client-guide-add').removeClass('hide');
            }

        } else {
            $('#client-guide-add').addClass('hide');
        }
    });

    $(document).on('click', '#client-guide-add', function () {
        let client_guide = $('#client-guide-name option:selected'),
            date = moment($('#client-guide-date').val(), 'YYYY-MM-DD').local().format('MMM DD, YYYY'),
            parent = client_guide.data('parent'),
            options = { day: 'numeric', month: 'short', year: 'numeric' },
            remove = '<a class="remove-client-guide-left-early"><i class="fa fa-times fa-fw fa-btn red" aria-hidden="true"></i></a>';

        $('#client-guide-left-early-list').append('<li class="my-2" data-parent="' + parent + '" data-id="' + client_guide.val() + '" data-date="' + $('#client-guide-date').val() + '">' + client_guide.html() + ' - ' + date + remove + '</li>');

        $('#client-guide-name').val('');
        $('#client-guide-date').val('').prop('disabled', true);

        filterSelected();
    });

    $(document).on('click', '.remove-client-guide-left-early', function () {
        $(this).parent().remove();
        filterSelected();
    })

    function filterSelected() {
        let selected = [];
        $('#client-guide-left-early-list li').each(function () {
            selected.push($(this).data('id'));
        });
        $('#client-guide-name option').each(function () {
            if (selected.includes(parseInt($(this).val()))) {
                $(this).addClass('hide');
            } else {
                $(this).removeClass('hide');
            }
        });
    }

    $(document).on('change', 'input[name="trip_evaluation[incident]"]', function () {
        if ($(this).val() == 1) {
            $('#incident_explanation_container').removeClass('hide');
            $('#incident_explanation').prop('disabled', false);
        } else {
            $('#incident_explanation_container').addClass('hide');
            $('#incident_explanation').prop('disabled', true)
        }
    });

    /**
     * Adds New Row For Guide Evaluation Day Journal
     */

    $(document).on('click', '.add-new-day', function () {
        let day = $('#trip_journal tr.days:last').data('day') + 1;
        $('#trip_journal tr.days:last').after('<tr class="days" data-day="' + day + '"><th>Day ' + day + '</th><td><textarea name="trip_evaluation_journal[day_' + day + '][summary]" class="form-control" rows="5"></textarea></td><td><textarea name="trip_evaluation_journal[day_' + day + '][route]" class="form-control" rows="5"></textarea></td><td><textarea name="trip_evaluation_journal[day_' + day + '][camp_location]" class="form-control" rows="5"></textarea></td></tr>');
    });

    $(document).on('click', '.add-new-aiare-day', function () {
        let day = $('#trip_journal tr.days:last').data('day') + 1;
        $('#trip_journal tr.days:last').after('<tr class="days" data-day="' + day + '"><th>Day ' + day + '</th><td><textarea name="trip_evaluation_journal[day_' + day + '][camp_location]" class="form-control" rows="5"></textarea></td><td><textarea name="trip_evaluation_journal[day_' + day + '][summary]" class="form-control" rows="5"></textarea></td></tr>');
    });

    $(document).on('click', '.add-new-weather-day', function () {
        let day = $('#trip-journal-weather tr.weather-day:last').data('day') + 1;
        console.log(day);
        $('#trip-journal-weather tr.weather-day:last').after('<tr class="weather-day" data-day="' + day + '"><th>Weather Day ' + day + '</th><td><textarea name="trip_evaluation_journal[weather_day_' + day + '][summary]" class="form-control" rows="5"></textarea></td><td><textarea name="trip_evaluation_journal[weather_day_' + day + '][route]" class="form-control" rows="5"></textarea></td><td><textarea name="trip_evaluation_journal[weather_day_' + day + '][camp_location]" class="form-control" rows="5"></textarea></td></tr>');
    });

    function handledErrorNotification(errors_array) {
        let msg = '';

        for (var i = 0; i < errors_array.length; i++) {
            let err = errors_array[i];
            msg += "<p class='mb-0'>" + err + "</p>";
        }

        let errors = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + msg + '</div>';

        $('#errorContainer').html(errors);

        window.scrollTo(0, 0);
    }

    $(document).on('click', '.save-evaluation', function (el) {

        el.preventDefault();

        let button = $(this);

        button.prop('disabled', true);

        let saveProgress = button.data('save-progress') ? 1 : 0;

        let success = function (response) {

            $('#errorContainer').empty();

            if (response.redirect) {
                window.location.href = response.redirect;
            }

            if (response.reload) {
                window.location = window.location;
            }

            if (response.errors) {
                handledErrorNotification(response.errors)
            }

            if (response.last_updated) {
                $('.save-progress-status span').html(response.last_updated);
            }

            $('#save-evaluation').html('Save Progress');
            $('#submit-evaluation').html('Finish Progress');
            $('#save-evaluation').prop('disabled', false);
            $('#submit-evaluation').prop('disabled', false);
        }

        let errors = function (response) {

            $('#save-evaluation').html('Save Progress');
            $('#submit-evaluation').html('Finish Progress');
            $('#save-evaluation').prop('disabled', false);
            $('#submit-evaluation').prop('disabled', false);
            window.scrollTo(0, 0);
        }

        button.html('<i class="fa fa-cog fa-spin fa-fw fa-btn"></i> Saving...');

        saveTripEvaluation(success, errors, saveProgress);
    });

    $(document).on('click', '#submit-evaluation', function (el) {
        el.preventDefault();

        let button = $(this);

        button.prop('disabled', true);

        let success = function (response) {

            $('#errorContainer').empty();

            if (response.redirect) {
                window.location.href = response.redirect;
            }

            if (response.reload) {
                window.location = window.location;
            }

            if (response.errors) {
                handledErrorNotification(response.errors)
            }

            if (response.last_updated) {
                $('.save-progress-status span').html(response.last_updated);
            }

            $('#save-evaluation').html('Save Progress');
            $('#submit-evaluation').html('Finish Progress');
            $('#save-evaluation').prop('disabled', false);
            $('#submit-evaluation').prop('disabled', false);
        }

        let errors = function (response) {

            $('#save-evaluation').html('Save Progress');
            $('#submit-evaluation').html('Finish Progress');
            $('#save-evaluation').prop('disabled', false);
            $('#submit-evaluation').prop('disabled', false);
            $('html, body').animate({
                scrollTop: $('.error:visible:first').offset().top
            }, 1000);
        }

        button.html('<i class="fa fa-cog fa-spin fa-fw fa-btn"></i> Saving...');

        if ($('#evaluation').valid()) {
            let saveProgress = false;
            saveTripEvaluation(success, errors, saveProgress);
        } else {
            button.prop('disabled', false);
            button.html("Finish Evaluation");
            $('html, body').animate({
                scrollTop: ($('.error:visible:first').offset().top - 100)
            }, 1000);
        }
    });

    function saveTripEvaluation(successCallback, errorsCallback, saveProgress) {

        let form = document.getElementById('evaluation');
        let formData = new FormData(form);

        // If save_progress flag is passed, don't expect to redirect
        formData.set('save_progress', saveProgress);

        http.sendAjax(form.getAttribute('action'), 'post', formData, successCallback, errorsCallback);
    }

    function initAutoSave() {

        autoSaveInitialized = true;

        let success = function (response) {

            if (response.errors) {
                handledErrorNotification(response.errors)
            }

            if (response.last_updated) {
                $('.save-progress-status span').html(response.last_updated);
            }

            $('#save-evaluation').html('Save Progress');
        }

        let errors = function (response) {
            let message = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>Error submitting evaluation</div>';
            $('#errorContainer').html(message);
            $('#save-evaluation').html('Save Progress');
            $('#submit-evaluation').html('Finish Progress');
            $('#save-evaluation').prop('disabled', false);
            $('#submit-evaluation').prop('disabled', false);
            window.scrollTo(0, 0);
        }

        setInterval(function () {
            if (autoSaveAttemptMax > autoSaves) {
                $('#save-evaluation').html('<i class="fa fa-cog fa-spin fa-fw fa-btn"></i>Auto Saving...');
                let save_progress = 1;
                saveTripEvaluation(success, errors, save_progress);
                autoSaves++;
            }
        }, autoSaveInterval);
    }

    $('#evaluation').focusin(function () {
        if (
            $('#evaluation').data('autosave') == 1 &&
            (
                autoSaveInitialized === false ||
                autoSaveAttemptMax === autoSaves
            )
        ) {
            console.log('autoSaveInitialized true');
            autoSaves = 0;
            initAutoSave();
        }
    });

    $(document).on('click', '.delete-avatar', function (el) {

        el.preventDefault();

        let previousState = $(this).html();

        $(this).removeClass('fa-times-circle-o').addClass('fa-cog fa-spin');

        $(this).attr('disabled', true);

        let success = function (response) {
            if (response.redirect) {
                window.location.href = response.redirect;
            }

            if (response.reload) {
                window.location = window.location;
            }

            if (response.errors) {

                $(this).prop('disabled', false);
                $(this).addClass('fa-times-circle-o').removeClass('fa-cog fa-spin');

                $.each(response.errors, function (key, value) {
                    $.each(value, function (k, v) {
                        let message = "<p class='mb-0'>" + v + "</p>";
                        let messageContainer = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + message + '</div>';
                        $(messageContainer).appendTo('#errorContainer');
                    });
                });

                window.scrollTo(0, 0);
            }


        }

        let errors = function (response) {
            console.log(response);

            $(this).prop('disabled', false);
            $(this).addClass('fa-times-circle-o').removeClass('fa-cog fa-spin');

            let message = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>Error submitting. Please contact AA technical support for assistance. </div>';

            $(message).appendTo('#errorContainer');
        }

        http.sendAjax($(this).data('href'), 'POST', null, success, errors);
    });
}